import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { YoutubeAnalyticsTagRankingSortOrder } from '@anytag/graphql';
import { defaultProfilePostsFilterSchema } from '../../ProfilePostsList';

export const YoutubeTagRankingSearchListSchema = SearchSchema.create({
  filter: defaultProfilePostsFilterSchema,
  sort: { field: YoutubeAnalyticsTagRankingSortOrder }
});

export type YoutubeTagRankingSearchListSchemaType = z.infer<typeof YoutubeTagRankingSearchListSchema>;
